// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreMenuComposer_container__Zt5xx"};